import React from 'react'
import {reduxForm} from 'redux-form'
import {apiUrl} from 'config/app';
require('es6-promise').polyfill();
import ShortenerDetailsContainer from 'containers/ShortenerDetailsContainer';

const validate = values => {
  const errors = {}
  if (!values.url) {
    errors.url = 'Enter a link to shorten.'
  } else if (!values.url.match(/^(http(s)?:\/\/)?(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3})([\w#/?.=\-\[\]&%~;:,|]*?)$/gm)) {
    errors.url = 'Enter a valid link.'
  }

  return errors
}

const asyncValidate = (values) => {
  if (typeof values.hash === 'undefined' || !values.hash) {
    return Promise.resolve(values.hash);
  }

  return fetch(`${apiUrl}/short/v1/link?hash=${values.hash}`, {method: 'HEAD'})
      .then(response => {
        if (response.status === 404) {
          return true;
        } else {
          // eslint-disable-next-line
          throw {hash: 'Such custom link already exists. Try a different one.'}
        }
      })

}



const ShortenerFormContainer = ({handleSubmit}) => {
  return (
      <div>
        <ShortenerDetailsContainer handleSubmit={handleSubmit}/>
      </div>
  )
}

export default reduxForm({
  form: 'shortener',
  validate,
  asyncValidate,
  asyncBlurFields: ['hash']
})(ShortenerFormContainer)





// WEBPACK FOOTER //
// ./src/containers/ShortenerFormContainer.jsx